import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./Datepicker.css";
import { DatepickerProps } from "../../CommonProps";
import { Spinner } from "@chakra-ui/react";
class Datepicker extends Component<DatepickerProps> {
  private datetimeRef: any;

  constructor(props: DatepickerProps) {
    super(props);
    this.datetimeRef = React.createRef();
  }

  renderDay = (props: any, currDate: any) => {
    const {
      availableAppointments,
      selectedDate,
      showLoader = false,
    } = this.props;

    // Disabled Dated If Confirm Button has clicked
    if (showLoader) {
      props.className += " cursor-disabled";
    }

    // Check if the date is a weekend
    const dayOfWeek = currDate.day(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      props.className += " date-picker-weekend";
    }
    const findDate = availableAppointments.find((x) =>
      currDate.startOf("day").isSame(x.dueDate, "day")
    );

    if (
      availableAppointments.some((x) =>
        currDate.startOf("day").isSame(x.dueDate, "day")
      )
    ) {
      props.className += " availableDates";
    }
    if (selectedDate && currDate.startOf("day").isSame(selectedDate, "day")) {
      props.className += " selectedDate";
    }
    return (
      <td {...props}>
        <span {...props} className="innerDate">
          {findDate?.showLoader ? (
            <Spinner size={"sm"} color="white" transitionDuration={"0.8s"} />
          ) : (
            currDate.date()
          )}
        </span>
      </td>
    );
  };

  isValidDate = (currentDate: any) => {
    const { availableAppointments } = this.props;
    const dayOfWeek = currentDate.day();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      return false;
    }
    if (
      availableAppointments?.filter(
        (x: any) =>
          currentDate.startOf("day").isSame(x.dueDate, "day") && x.budget == 0
      ).length > 0
    ) {
      return false;
    }
    if (
      availableAppointments?.filter((x: any) =>
        currentDate.startOf("day").isSame(x.dueDate, "day")
      ).length === 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  handleDateChange = (date: any) => {
    const { onDateSelected } = this.props;
    onDateSelected(date);
  };

  render() {
    const { dropoffSelectedDate } = this.props;

    return (
      <Datetime
        ref={this.datetimeRef}
        value={dropoffSelectedDate}
        open
        input={false}
        renderDay={this.renderDay}
        isValidDate={this.isValidDate}
        onChange={this.handleDateChange}
      />
    );
  }
}

export default Datepicker;
